import theme from "./theme"
import { AGENCY } from "./agency"
import { buyerCategoriesBayut, buyerCategoriesZameen } from "./configConstants"

//Get Base url from env
const apiBaseURL = () => process.env.REACT_APP_API_BASE_URL
const getCompanyIcon = agency => {
  if (typeof window === "undefined") return null
  const { IconZameenInverse, IconBayut } = require("../components/svg")
  return agency === "zameen" ? IconZameenInverse : IconBayut
}

const baseZameenConfig = {
  propertyType: "1",
  propertySubType: { id: 8, name: "Flats", value: 8 },
}

const baseBayutConfig = {
  propertyType: "343",
  propertySubType: { id: 347, name: "Flats", value: 347 },
}

const agenciesConfig = {
  zameen: {
    agency: "zameen",
    get companyIcon() {
      return getCompanyIcon("zameen")
    },
    lensSubTenant: "propforce_zameen",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "PK",
    currency: "PKR",
    countryId: 155,
    timezone: "Asia/Karachi",
    city: "Lahore",
    coordinates: {
      longitude: 74.3587,
      latitude: 31.5204,
    },
    allowBackDateForTaskCompletion: true,
    ...baseZameenConfig,
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
    ],
    locationRequired: false,
    allowMaqsamCall: false,
    showTermsAndConditionsAR: false,
    allowGrandStreamCall: false,
    mktgAddProjectTypeKey: "developers_ads_project",
    buyerCategoryDefaultValue: "pakistani",
    buyerCategoryOptions: buyerCategoriesZameen,
    allowPaymentReceipt: true,
    passportRequired: true,
    ibanAndNationalAddressRequired: false,
    downloadBookingForm: false,
    isSalesPlaybookEnabled: true,
  },
  "training-zameen": {
    agency: "zameen",
    get companyIcon() {
      return getCompanyIcon("zameen")
    },
    lensSubTenant: "propforce_zameen_test",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "PK",
    currency: "PKR",
    countryId: 155,
    timezone: "Asia/Karachi",
    city: "Lahore",
    coordinates: {
      longitude: 74.3587,
      latitude: 31.5204,
    },
    allowBackDateForTaskCompletion: true,
    ...baseZameenConfig,
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
    ],
    locationRequired: false,
    allowMaqsamCall: false,
    showTermsAndConditionsAR: false,
    allowGrandStreamCall: false,
    mktgAddProjectTypeKey: "developers_ads_project",
    buyerCategoryDefaultValue: "pakistani",
    buyerCategoryOptions: buyerCategoriesZameen,
    allowPaymentReceipt: true,
    passportRequired: true,
    ibanAndNationalAddressRequired: false,
    downloadBookingForm: false,
    isSalesPlaybookEnabled: true,
  },
  sandbox: {
    agency: "zameen",
    get companyIcon() {
      return getCompanyIcon("zameen")
    },
    lensSubTenant: "propforce_sandbox",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "AE",
    currency: "AED",
    countryId: 210,
    timezone: "Asia/Karachi",
    allowEmailPassLogin: true,
    isLocationOptional: true,
    city: "Lahore",
    coordinates: {
      longitude: 74.3587,
      latitude: 31.5204,
    },
    allowBackDateForTaskCompletion: true,
    ...baseZameenConfig,
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
    ],
    locationRequired: false,
    allowMaqsamCall: false,
    showTermsAndConditionsAR: false,
    allowGrandStreamCall: false,
    addStaffFieldsOptional: true,
    showPartnersList: true,
    showCampaignOnlyFields: true,
    mktgAddProjectTypeKey: "developer_marketing",
    allowPaymentReceipt: true,
    buyerCategoryDefaultValue: "pakistani",
    buyerCategoryOptions: buyerCategoriesZameen,
    ibanAndNationalAddressRequired: false,
    downloadBookingForm: false,
    isSalesPlaybookEnabled: true,
  },
  bayut: {
    agency: "bayut",
    get companyIcon() {
      return getCompanyIcon("bayut")
    },
    lensSubTenant: "propforce_bayut",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "SA",
    countryId: 177,
    currency: "SAR",
    currencySymbolUnicode: "0xea",
    currencySymbolClass: "saudiSymbol",
    timezone: "Asia/Riyadh",
    isLocationOptional: true,
    city: "Riyadh",
    coordinates: {
      longitude: 46.6753,
      latitude: 24.7136,
    },
    allowBackDateForTaskCompletion: false,
    ...baseBayutConfig,
    languages: [
      {
        id: 2,
        key: "ar",
        label: "AR",
        jsFormat: "en-US", //"ar-EG",
        rtl: true,
        darkMode: false,
        topMenu: false,
        locale: "ar",
        font: "https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;700&display=swap",
        // momentLocale: momentAr,
      },
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        locale: "en",
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
        // momentLocale: momentEn,
      },
    ],
    locationRequired: false,
    allowMaqsamCall: true,
    showTermsAndConditionsAR: true,
    allowGrandStreamCall: true,
    buyerCategoryDefaultValue: "saudi",
    buyerCategoryOptions: buyerCategoriesBayut,
    allowPaymentReceipt: false,
    passportRequired: false,
    ibanAndNationalAddressRequired: true,
    downloadBookingForm: true,
    isSalesPlaybookEnabled: true,
  },
  "bayut-stage": {
    agency: "bayut-stage",
    get companyIcon() {
      return getCompanyIcon("bayut")
    },
    lensSubTenant: "propforce_bayut_test",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "SA",
    countryId: 177,
    currency: "SAR",
    currencySymbolUnicode: "0xea",
    currencySymbolClass: "saudiSymbol",
    timezone: "Asia/Riyadh",
    allowBackDateForTaskCompletion: false,
    ...baseBayutConfig,
    languages: [
      {
        id: 2,
        key: "ar",
        label: "AR",
        jsFormat: "en-US", //"ar-EG",
        rtl: true,
        darkMode: false,
        topMenu: false,
        locale: "ar",
        font: "https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;700&display=swap",
        // momentLocale: momentAr,
      },
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        locale: "en",
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
        // momentLocale: momentEn,
      },
    ],
    locationRequired: false,
    allowMaqsamCall: true,
    allowGrandStreamCall: true,
    mktgAddProjectTypeKey: "developers_ads_project",
    buyerCategoryDefaultValue: "saudi",
    buyerCategoryOptions: buyerCategoriesBayut,
    allowPaymentReceipt: false,
    ibanAndNationalAddressRequired: true,
    downloadBookingForm: true,
    isSalesPlaybookEnabled: true,
  },
  "training-bayut": {
    agency: "bayut",
    get companyIcon() {
      return getCompanyIcon("bayut")
    },
    lensSubTenant: "propforce_bayut_test",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "SA",
    countryId: 177,
    currency: "SAR",
    currencySymbolUnicode: "0xea",
    currencySymbolClass: "saudiSymbol",
    timezone: "Asia/Riyadh",
    isLocationOptional: true,
    city: "Riyadh",
    coordinates: {
      longitude: 46.6753,
      latitude: 24.7136,
    },
    allowBackDateForTaskCompletion: false,
    ...baseBayutConfig,
    languages: [
      {
        id: 2,
        key: "ar",
        label: "AR",
        jsFormat: "en-US", //"ar-EG",
        rtl: true,
        darkMode: false,
        topMenu: false,
        locale: "ar",
        font: "https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@400;700&display=swap",
        // momentLocale: momentAr,
      },
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        locale: "en",
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
        // momentLocale: momentEn,
      },
    ],
    locationRequired: false,
    allowMaqsamCall: true,
    showTermsAndConditionsAR: true,
    allowGrandStreamCall: true,
    mktgAddProjectTypeKey: "developers_ads_project",
    buyerCategoryDefaultValue: "saudi",
    buyerCategoryOptions: buyerCategoriesBayut,
    allowPaymentReceipt: false,
    passportRequired: false,
    ibanAndNationalAddressRequired: true,
    downloadBookingForm: true,
    isSalesPlaybookEnabled: true,
  },
  "sandbox-staging": {
    agency: "sandbox-staging",
    get companyIcon() {
      return getCompanyIcon("bayut")
    },
    lensSubTenant: "propforce_sandbox",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "AE",
    currency: "AED",
    countryId: 210,
    timezone: "Asia/dubai",
    allowEmailPassLogin: true,
    isLocationOptional: true,
    allowBackDateForTaskCompletion: true,
    allowAdvertisementLeadsEditable: true,
    showPartnersOnCampaignListing: true,
    ...baseZameenConfig,
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
    ],
    locationRequired: false,
    allowGrandStreamCall: false,
    addStaffFieldsOptional: true,
    showPartnersList: true,
    showCampaignOnlyFields: true,
    mktgAddProjectTypeKey: "developer_marketing",
    passportRequired: false,
    ibanAndNationalAddressRequired: true,
    downloadBookingForm: false,
    isSalesPlaybookEnabled: true,
  },
  uae: {
    agency: "uae",
    get companyIcon() {
      return getCompanyIcon("bayut")
    },
    lensSubTenant: "propforce_uae",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "AE",
    currency: "AED",
    countryId: 210,
    timezone: "Asia/dubai",
    allowEmailPassLogin: true,
    isLocationOptional: true,
    allowBackDateForTaskCompletion: true,
    showPartnersOnCampaignListing: true,
    ...baseZameenConfig,
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
    ],
    locationRequired: false,
    allowGrandStreamCall: false,
    addStaffFieldsOptional: true,
    showPartnersList: true,
    showCampaignOnlyFields: true,
    mktgAddProjectTypeKey: "developer_marketing",
    buyerCategoryOptions: buyerCategoriesBayut,
    passportRequired: false,
    ibanAndNationalAddressRequired: true,
    downloadBookingForm: false,
    isSalesPlaybookEnabled: true,
  },
  dgm: {
    agency: "dgm",
    get companyIcon() {
      return getCompanyIcon("bayut")
    },
    lensSubTenant: "propforce_dgm",
    apiBaseURL,
    odysseyApiURL: process.env.REACT_APP_ODYSSEY_BASE_URL + "/api",
    countryCode: "AE",
    currency: "AED",
    countryId: 210,
    timezone: "Asia/dubai",
    allowEmailPassLogin: true,
    isLocationOptional: true,
    allowBackDateForTaskCompletion: true,
    ...baseZameenConfig,
    languages: [
      {
        id: 1,
        key: "en",
        label: "EN",
        jsFormat: "en-US",
        rtl: false,
        darkMode: false,
        topMenu: false,
        font: "https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600&display=swap",
      },
    ],
    locationRequired: false,
    allowGrandStreamCall: false,
    addStaffFieldsOptional: true,
    showPartnersList: true,
    showCampaignOnlyFields: true,
    mktgAddProjectTypeKey: "developer_marketing",
    buyerCategoryOptions: buyerCategoriesBayut,
    ibanAndNationalAddressRequired: true,
    downloadBookingForm: false,
    isSalesPlaybookEnabled: true,
  },
}

console.log("+++++++++++++++++agane", AGENCY)
const configs = agenciesConfig[AGENCY]

export { theme, configs }
